var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 7 5"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.881,
    height: 4.469,
    x: 0.197,
    y: 1.306,
    fill: "#000",
    rx: 0.441,
    transform: "rotate(-45 .197 1.306)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.881,
    height: 4.507,
    fill: "#000",
    rx: 0.441,
    transform: "scale(-1 1)rotate(-45 -1.729 8.538)"
  })));
};
export default SvgChevron;